const EXPLAINED_CALLBACK_ERRORS = {
    email_unverified: true,
    invalid_email: true
};
export const toExplainedOAuthFailure = (callbackError)=>Object.hasOwn(EXPLAINED_CALLBACK_ERRORS, callbackError) ? callbackError : null;
